import traverseObject from "./traverseObject";

const sortByKey = <T extends { [key: string]: any }>(
    list: T[],
    key: string
) => {
    const sortedList = list.sort((a: T, b: T) => {
        let c = [traverseObject(a, key), traverseObject(b, key)];

        // have to deal with both null and undefine cases
        if (c[0] === null || c[0] === undefined) return 1; // undefined, x -> x, undefined
        if (c[1] === null || c[1] === undefined) return -1; // x , undefined -> x, undefined

        if (typeof c[0] === "string" && typeof c[1] === "string") {
            let [str1, str2] = c as unknown as [string, string];
            if (str1.toLocaleLowerCase() < str2.toLocaleLowerCase()) return -1;
            if (str1.toLocaleLowerCase() > str2.toLocaleLowerCase()) return 1;
        }

        if (c[0] < c[1]) return -1;
        if (c[0] > c[1]) return 1;
        return 0;
    });
    return sortedList;
};

export default sortByKey;
